module.exports = __webpack_public_path__ + "img/illu-poo.54494e3b.svg";